import apiService from "../apiService";

const MAP_FIELD_URL = "map_import_fields";
const mapFieldService = {
  async createFieldsMapping(payload) {
    try {
      const response = await apiService.post(`/${MAP_FIELD_URL}/fields_mapping`, payload);
      return response.data;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  },

  async getAllExistingFields(module_type) {
    try {
      const response = await apiService.get(`/${MAP_FIELD_URL}/existing_fields/${module_type}`);
      return response.data;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  },

  async getAllSources() {
    try {
      const response = await apiService.get(`/${MAP_FIELD_URL}/fields_mapping`);
      return response.data;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  },

  async getSingleSource(id) {
    try {
      const response = await apiService.get(`/${MAP_FIELD_URL}/fields_mapping/${id}`);
      return response.data;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  },
  

  async updateContact(payload, id) {
    try {
      const response = await apiService.put(`/${MAP_FIELD_URL}/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  },

  async deleteMappedField(id) {
    try {
      const response = await apiService.delete(`/${MAP_FIELD_URL}/fields_mapping/${id}`);
      return response.data;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  },

};

export default mapFieldService;
